import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../../context/firebase';
import * as PROJECT_CODE from '../../../constants/projectCode';
import {
	onUnityUpdateMessage,
	ReceiveMessageFromUnity,
	GoOneStateBack,
} from '../UnityLogic/ReceiveMessage';
import { CircularProgress } from '@material-ui/core';
import './UnityController.css';
import {
	PopulateCategories,
	PopulateUnits,
	PopulateRooms,
	PopulateUpgradeSelections,
	PopulateUpgradeOptions,
} from '../UnityUI/UnityPopulateMenus';
import { GetFloorPlanImageInformation } from '../UnityFirebaseCalls/FirebaseUnityInformation';
import { GetFloorImage } from '../UnityFirebaseCalls/FirebaseGetImage';
import { connect } from 'react-redux';

//does this make it gloabal
var zoomedOut = true;

const UnityController = ({ userType }) => {
	console.log('Unity Controller Starting');

	const { firebase } = useContext(FirebaseContext);

	//lets get all the units list of floor plan images
	const [unitsFloorPlansUnity, setUnitsFloorPlans] = useState();

	//This will be in control of what UI menu should be showing
	const lastState = '';
	const [currentUiState, setUiState] = useState('doNothing');

	onUnityUpdateMessage.setStateToDoNothing = () => {
		setUiState('doNothing');
	};

	const getUnityFloorPlanInfo = async () => {
		var returnVal;

		await GetFloorPlanImageInformation().then((returned) => {
			returnVal = returned;

			console.log('Received Floor plans ', returned);
		});

		var allUnits = Object.keys(returnVal.unit);
		var i;
		returnVal['unitURLs'] = {};
		for (i = 0; i < allUnits.length; i++) {
			var allFloorImages = returnVal.unit[allUnits[i]];
			var x;
			returnVal['unitURLs'][allUnits[i]] = {};
			for (x = 0; x < allFloorImages.length; x++) {
				var returnedUrl;
				// eslint-disable-next-line no-loop-func
				await GetFloorImage(allFloorImages[x], firebase).then(
					(newReturn) => {
						returnedUrl = newReturn;
					}
				);

				//console.log("Units URL ", allUnits[i] + " " , allFloorImages[x])

				returnVal['unitURLs'][allUnits[i]][allFloorImages[x]] =
					returnedUrl;
			}
		}

		setUnitsFloorPlans(returnVal);
	};

	if (unitsFloorPlansUnity === undefined) {
		getUnityFloorPlanInfo();
	}

	const onUnityReceiveMessage = () => {
		console.log('Unity Controller is working correctly ');
		console.log('Current Data ', onUnityUpdateMessage.currentDataString);
		console.log('Last Data ', onUnityUpdateMessage.lastDataString);

		var updateMessage = ReceiveMessageFromUnity(
			onUnityUpdateMessage.currentDataString,
			currentUiState
		);

		onUnityUpdateMessage.currentData = updateMessage.newMessage;

		console.log('Updated Message ', updateMessage);

		if (updateMessage.updateState === true) {
			setUiState(updateMessage.newState);
		}
	};

	onUnityUpdateMessage.callback = () => {
		onUnityReceiveMessage();
	};
	onUnityUpdateMessage.setLoading = () => {
		setUiState('loading');
		console.log('Unity Controller ', currentUiState);
	};
	onUnityUpdateMessage.setFurioosOff = () => {
		setUiState('doNothing');
		console.log('Unity Controller ', currentUiState);
	};

	//listOfAllStates
	//doNothing
	//loading
	//showCategories
	//showUnits
	//showRoomsZoomedOut
	//showRoomsZoomedIn I dont think we need this we will just have them zoomed in whenever in upgrades
	//showUpgradeOptions
	//showUpgradeSelection

	if (userType === 'client') {
		return <></>;
	}

	return (
		<>
			{renderBasedOnState(currentUiState, unitsFloorPlansUnity, userType)}
		</>
	);
};

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
});

export default connect(mapStateToProps)(UnityController);

const renderBasedOnState = (currentUiState, floorPlanInfo, userType) => {
	switch (currentUiState) {
		case 'doNothing':
			return <div></div>;
		case 'loading':
			return <div></div>;
		case 'showCategories':
			return <div></div>; //return(<div className='layout_collumn_unity'>{UnityUIHolder(()=>{return(PopulateCategories(onUnityUpdateMessage.currentData))})}</div>)//un comment this if we use riverbend
		case 'showUnits':
			return (
				<div className='layout_collumn_unity'>
					{UnityUIHolder(() => {
						return PopulateUnits(
							onUnityUpdateMessage.currentData,
							floorPlanInfo
						);
					})}
				</div>
			);
		case 'showRoomsZoomedOut': //Not only for zoomed out
			return (
				<div className='layout_collumn_unity'>
					{UnityUIHolder(() => {
						return PopulateRooms(onUnityUpdateMessage.currentData);
					})}
					<div className='layout_zoom_button_holder_unity'>
						{/* {ZoomOutButton(userType)}
                        {ZoomInButton(userType)} */}
					</div>
				</div>
			);
		case 'showUpgradeOptions':
			return <div></div>; //return(<div className='layout_collumn_unity'>{UnityUIHolder(()=>{return(PopulateUpgradeOptions(onUnityUpdateMessage.currentData))})}</div>)
		case 'showUpgradeSelection':
			return <div></div>; //return(<div className='layout_collumn_unity'>{UnityUIHolder(()=>{return(PopulateUpgradeSelections(onUnityUpdateMessage.currentData))})}</div>)
		default:
			console.log('SHOULD NEVER BE HERE');
	}
};

const UnityUIHolder = (AttachedComponent) => {
	//first Div will contain all the new populated items
	return <>{AttachedComponent()}</>;
};

const BackButton = (currentUiState) => {
	return (
		<button
			onClick={() => {
				onUnityUpdateMessage.goBack();
				GoOneStateBack(currentUiState);
			}}
		>
			Go Back
		</button>
	);
};

const ZoomOutButton = (userType) => {
	if (userType === 'client') {
		return <></>;
	} else {
		return (
			<button
				className='zoom_button_unity'
				onClick={() => {
					onUnityUpdateMessage.zoomTo('0');
					zoomedOut = true;
				}}
			>
				+
			</button>
		);
	}
};

const ZoomInButton = (userType) => {
	if (userType === 'client') {
		return <></>;
	} else {
		return (
			<button
				className='zoom_button_unity'
				onClick={() => {
					onUnityUpdateMessage.zoomTo('1');
					zoomedOut = false;
				}}
			>
				-
			</button>
		);
	}
};
